import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { AnimatePresence, motion } from "framer-motion";
import {
  Home,
  About,
  Contact,
  Login,
  Register,
  MyAccount,
  AddFriends,
  FullSchedule,
  BetPage,
  MyBets,
  RenderRequests,
  UpdateMyAccount,
  UserManagement,
  EditUserAsAdmin,
  NflWeeklySchedulePage,
  Messages,
  MiniGamesPage,
  FriendsLeaderboard,
  RivalryMode,
  GameDayChallenges,
  DailyHighlights,
} from './Pages';
import { NavBar } from './Components';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { RedirectBasedOnLogin } from './Data';

import UseAuthListener from "./Components/authRedirectHandler";
import ResetPassword from './Pages/ResetPassword';
import { useTheme } from './Components/theme/ThemeContext.jsx';
import FloatingMessenger from "./Components/messages/FloatingMessenger.jsx";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <Routes location={location}>
          {/* Public Routes */}
          <Route path="/FriendlyBets" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/PasswordReset" element={<ResetPassword />} />
          {/* Protected Routes */}
          <Route
            path="/myAccount"
            element={
              <RedirectBasedOnLogin>
                <MyAccount />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/addFriends"
            element={
              <RedirectBasedOnLogin>
                <AddFriends />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/leaderboard"
            element={
              <RedirectBasedOnLogin>
                <FriendsLeaderboard />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/rivalries"
            element={
              <RedirectBasedOnLogin>
                <RivalryMode />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/challenges"
            element={
              <RedirectBasedOnLogin>
                <GameDayChallenges />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/highlights"
            element={
              <RedirectBasedOnLogin>
                <DailyHighlights />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/fullSchedule"
            element={
              <RedirectBasedOnLogin>
                <FullSchedule />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/Messages"
            element={
              <RedirectBasedOnLogin>
                <Messages />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/betPage"
            element={
              <RedirectBasedOnLogin>
                <BetPage />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/MyBets"
            element={
              <RedirectBasedOnLogin>
                <MyBets />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/Notifications"
            element={
              <RedirectBasedOnLogin>
                <RenderRequests />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/UpdateMyAccount"
            element={
              <RedirectBasedOnLogin>
                <UpdateMyAccount />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/UserManagement"
            element={
              <RedirectBasedOnLogin>
                <UserManagement />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/EditUserAsAdmin"
            element={
              <RedirectBasedOnLogin>
                <EditUserAsAdmin />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/NflSchedule"
            element={
              <RedirectBasedOnLogin>
                <NflWeeklySchedulePage />
              </RedirectBasedOnLogin>
            }
          />
          <Route
            path="/mini-games"
            element={
              <RedirectBasedOnLogin>
                <MiniGamesPage />
              </RedirectBasedOnLogin>
            }
          />

          <Route path="*" element={<Home />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  const { theme, activeCardTheme } = useTheme();
  const appClassName =
    theme === "dark"
      ? "app-shell app-shell--dark"
      : "app-shell";

  return (
    <div className={`${appClassName} app-shell--cards-${activeCardTheme}`}>
      <BrowserRouter>
        <NavBar />
        <UseAuthListener />
        <AnimatedRoutes />
        <FloatingMessenger />
      </BrowserRouter>
    </div>
  );
}
export default App;
